import React from "react";
import { Instagram, MessageCircle } from "lucide-react";

/**
 * FloatingContact — sticky bottom-right WhatsApp + Instagram buttons.
 * High-leverage inquiry conversion for luxury event site.
 */
export default function FloatingContact() {
  const wa =
    "https://wa.me/306943167877?text=" +
    encodeURIComponent(
      "Hello! I am interested in an event with Lumière Entertainment."
    );
  return (
    <div
      className="fixed bottom-6 left-6 z-50 flex flex-col gap-3 md:bottom-8 md:left-8"
      data-testid="floating-contact"
    >
      <a
        href={wa}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact via WhatsApp"
        data-testid="fab-whatsapp"
        className="group flex items-center gap-3 bg-[#25D366] hover:bg-[#1ea855] text-white pl-3 pr-4 py-3 rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-0.5"
      >
        <MessageCircle size={20} strokeWidth={2.2} className="flex-shrink-0" />
        <span className="hidden group-hover:inline sm:inline text-[12px] font-semibold tracking-wide whitespace-nowrap">
          WhatsApp
        </span>
      </a>
      <a
        href="https://instagram.com/stam_kanta"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow on Instagram"
        data-testid="fab-instagram"
        className="group flex items-center gap-3 text-white pl-3 pr-4 py-3 rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-0.5"
        style={{
          background:
            "linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
        }}
      >
        <Instagram size={20} strokeWidth={2.2} className="flex-shrink-0" />
        <span className="hidden group-hover:inline sm:inline text-[12px] font-semibold tracking-wide whitespace-nowrap">
          @stam_kanta
        </span>
      </a>
    </div>
  );
}
